import request from '../util/request'; //引入request.js

export function putData(info,type) {
	return request({
		url: 'api/comm/customer',
		method: 'post',
    data:{
      info:info,
      type:type
    }
	});
}



// WEBPACK FOOTER //
// ./src/api/putData.js